import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { postSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const u = await postSession(sessionId);
        setUser(u);
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/account", { replace: true, state: { user: u } });
      } catch {
        setError(true);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bone gap-4">
      <div className="w-14 h-14 rounded-full bg-forest flex items-center justify-center animate-pulse">
        <Sparkles className="w-6 h-6 text-white" strokeWidth={1.5} />
      </div>
      <p className="text-stone">{error ? "Sign-in failed. Please try again." : "Signing you in…"}</p>
      {error && (
        <button onClick={() => navigate("/login")} className="text-forest font-semibold">
          Back to sign in
        </button>
      )}
    </div>
  );
}
